import React, { useState, useEffect } from 'react';
import { postRequest } from "../../utils/networking";
import { apiUrls } from "../../utils/url";

export default function Mission() {
  const [missionCards, setMissionCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchMissions = async () => {
    try {
      const getApi = apiUrls.getmissioncard || '/ecomcourse/missioncard/getmissioncard';
      const response = await postRequest(getApi, {});
      if (response && response.status === "S" && Array.isArray(response.data)) {
        setMissionCards(response.data);
      } else if (Array.isArray(response)) {
        setMissionCards(response);
      }
    } catch (error) {
      console.log("Error fetching missions", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMissions();
  }, []);

  const icons = [
    (
      <svg className="w-8 h-8 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
      </svg>
    ),
    (
      <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>
      </svg>
    )
  ];

  return (
    <section id="mission" className="py-16 bg-gradient-to-br from-white via-amber-50/30 to-orange-50/20 relative overflow-hidden dot-pattern">
      <div className="absolute top-0 right-0 w-96 h-96 -mr-20 -mt-20 rounded-full bg-amber-100 opacity-50 blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 -ml-20 -mb-20 rounded-full bg-orange-100 opacity-40 blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100/80 border border-orange-200 text-xs font-bold text-orange-600 tracking-wider uppercase mb-4">
            <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse"></span>
            Our Goal
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6 tracking-tight">
            Our <span className="bg-gradient-to-r from-amber-500 to-orange-500 bg-clip-text text-transparent">Mission</span>
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600 text-base md:text-lg leading-relaxed">
            Empowering entrepreneurs with the required tools and knowledge to succeed in the digital commerce world.
          </p>
        </div>

        {isLoading ? (
          <div className="flex justify-center items-center py-10">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
          </div>
        ) : missionCards.length > 0 ? (
          <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
            {missionCards.map((card, index) => (
              <div
                key={card.rcid || card.id || index}
                className="group bg-white/80 backdrop-blur-sm rounded-3xl p-6 md:p-10 border border-gray-100 border-l-4 border-l-amber-500 relative overflow-hidden transition-all duration-300 hover:-translate-y-2"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-amber-50 to-orange-50 rounded-bl-full -mr-8 -mt-8 transition-transform duration-500 group-hover:scale-110"></div>
                
                <div className="absolute -bottom-6 -right-2 text-[120px] font-black text-gray-50 z-0 select-none group-hover:text-amber-50/50 transition-colors duration-300">
                  {String(index + 1).padStart(2, '0')}
                </div>

                <div className="relative z-10">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center border border-amber-100 shrink-0">
                      {icons[index % icons.length]}
                    </div>

                    <h3 className="text-xl md:text-2xl lg:text-xl  font-bold text-gray-900">
                      {card.title}
                    </h3>
                  </div>

                  <p className="text-gray-600 leading-relaxed text-sm text-justify whitespace-pre-line">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-10">
            {/* No missions found. */}
          </div>
        )}
      </div>
    </section>
  );
}